import { styled } from "@mui/system";

export const StyledSearchedAppInfoDocumentsWrapper = styled("div")(({ theme }) => ({
  marginTop: "24px",
  borderRadius: "8px",
  boxShadow: "0 1px 16px 0 rgba(0, 0, 0, 0.1)",
  backgroundColor: "#ffffff",
  marginBottom: "20px",
  width: "100%",
  "& .applicationRow": {
    borderBottom: "1px solid #e6e6e6",
    "&:last-of-type": {
      border: "none"
    },
    display: "flex",
    alignItems: "center",
    padding: "24px 20px 19px 30px",
    "@media (max-width: 500px)": {
      padding: "15px 5px"
    }
  },
  "& .checkListData": {
    fontSize: "14px",
    lineHeight: 1.33,
    color: "#86868b",
    marginTop: 5,
    maxWidth: "50%",
    width: "50%",
    "&:first-of-type": {
      wordBreak: "break-all",
      paddingRight: "0.8rem"
    },
    "&:nth-of-type(2)": {
      width: "20%",
      "@media (max-width: 500px)": {
        width: "50%"
      }
    },
    "&:last-of-type": {
      width: "30%"
    },
    "&.heading": {
      fontWeight: 600,
      color: "#000"
    }
  }
}));

export const StyledDocumentsContentWrapper = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  height: "62px",
  margin: "20px 35px 20px 25px",
  "& .nameField": {
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: 1.33,
    color: "#373737"
  },
  "& .userInfo": {
    display: "flex",
    flexDirection: "column",
    flex: 1,
    margin: "0 16px"
  }
}));

export const StyledDocumentsErrorWrapper = styled("div")(({ theme }) => ({
  fontWeight: 600,
  fontSize: "20px",
  marginBottom: "24px"
}));

export const StyledDocumentTitle = styled("h4")(({ theme }) => ({
  marginTop: "0px",
  color: "#373737",
  fontSize: "15px",
  alignItems: "center",
  fontWeight: "600"
}));
